import { z } from "zod";

export function makeEmailUpdateSchema(currentEmail: string) {
  return z
    .object({
      newEmail: z
        .string()
        .min(1, "Email is required")
        .email("Please enter a valid email address"),
    })
    .refine((data) => data.newEmail !== currentEmail, {
      message: "New email must be different from your current email",
      path: ["newEmail"],
    });
}
